import classNames from 'classnames'
import { forwardRef } from 'react'
import { Button, ButtonProps } from '~/components/Button'
import { ThumbUpFilledIcon } from '~/theme/icons'

const strings = {
  success: 'Gespeichert',
}
export type ShowSuccessButtonProps = ButtonProps & {
  showSuccess: boolean
  hideSuccessLabel?: boolean
}

export const ShowSuccessButton = forwardRef<
  HTMLButtonElement,
  ShowSuccessButtonProps
>(
  (
    { children, showSuccess, hideSuccessLabel = false, className, ...props },
    ref,
  ) => {
    return (
      <Button
        className={classNames(
          className,
          'overflow-hidden', // required for the slide animation
          showSuccess && 'bg-green-500 hover:bg-green-500',
        )}
        ref={ref}
        {...props}
      >
        <span
          className={classNames(
            'duration-500',
            showSuccess
              ? '-translate-x-[80%] opacity-0'
              : 'translate-x-0 opacity-100',
          )}
          aria-hidden={showSuccess}
        >
          {children}
        </span>
        <span
          className={`absolute flex h-full w-full items-center justify-center transition-all duration-500 ${
            showSuccess
              ? 'translate-x-0 opacity-100'
              : 'translate-x-full opacity-0'
          }`}
          aria-hidden={!showSuccess}
        >
          {!hideSuccessLabel && (
            <span className={'mr-2 text-green-900'}>{strings.success}</span>
          )}
          <span
            className={classNames(
              'transition-all delay-100 duration-500',
              showSuccess ? 'translate-x-0' : 'translate-x-full',
            )}
          >
            <ThumbUpFilledIcon
              className={classNames(
                'w-6 origin-[50%_50%] text-green-900',
                showSuccess && 'animate-[zoom-in-with-bounce_1.2s_ease-in-out]',
              )}
            />
          </span>
        </span>
      </Button>
    )
  },
)

ShowSuccessButton.displayName = 'SuccessButton'
